import { capitalizeFirstLetter } from "./capitalizeFirstLetter"

export const capitalizeEveryWord = (text: string): string => {
    return text
        .split(/\s/g)
        .map(capitalizeFirstLetter)
        .join(" ")
}